import { create } from "zustand";
import { deleteData, getData, postData, putData } from "../utils/formHelpers";
import { UserType } from "../../app/types/genericTables.types";
import { errorAlert, successAlert } from "../../app/utils/alerts";
import axios from "axios";
export const mappingUser = (user: any) => {
  return {
    id: user?.id,
    name: user?.name,
    last_name: user?.last_name,
    email: user?.email,
    roles: user?.roles,
    username: user?.username,
    password: user?.password,
    mobile_phone: user?.mobile_phone,
    phone: user?.phone,
    address: user?.address,
    country: user?.country,
    province: user?.province,
    city: user?.city,
    postal_code: user?.postal_code,
    dni: user?.dni,
    workstation: user?.workstation,
  };
};

type UseUserType = {
  userList: UserType[];
  get: (id: UserType["id"]) => UserType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
  save: (user: Partial<UserType>) => Promise<boolean>;
  remove: (id: UserType["id"]) => Promise<void>;
  resertPassword: (email: string) => Promise<void>;
};

export const useUser = create<UseUserType>((set, get) => ({
  loading: false,
  userList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().userList.find((user) => user.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/users";
      const { data: response } = await getData(endpoint);
      set(() => ({
        userList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching userList:", error);
      set({ loading: false });
    }
  },
  save: async (user: Partial<UserType>) => {
    set({ loading: true });
    try {
      const isNew = !user?.id;
      const endpoint = `/users/${isNew ? "create" : user.id + "/edit"}`;
      const response = isNew
        ? await postData(endpoint, mappingUser(user))
        : await putData(endpoint, mappingUser(user));
      if (response.success) {
        successAlert("Usuario guardado correctamente");
        get().fetchAll();
      } else {
        errorAlert("Error al guardar el usuario");
      }
      return response.success;
    } catch (error) {
      errorAlert("Error al guardar el usuario");
      return false;
    } finally {
      set({ loading: false });
    }
  },
  remove: async (id) => {
    set({ loading: true });
    try {
      const endpoint = `/users/${id}`;
      const response = await deleteData(endpoint);
      if (response.success) {
        successAlert("Usuario eliminado correctamente");
        get().fetchAll();
      } else {
        errorAlert("Error al eliminar el usuario");
      }
    } catch (error) {
      errorAlert("Error al eliminar el usuario");
      console.error("Error deleting useUser:", error);
    } finally {
      set({ loading: false });
    }
  },
  resertPassword: async (email: string) => {
    set({ loading: true });
    try {
      const endpoint = `${process.env.REACT_APP_BASE_URL}/reset-password/forgot`;
      const response = await axios.post(endpoint, { email });
      if (response.data) {
        successAlert("Email enviado correctamente");
      } else {
        errorAlert("Error al enviar el email");
      }
    } catch (error) {
      errorAlert("Error al enviar el email");
      console.error("Error sending email:", error);
    } finally {
      set({ loading: false });
    }
  },
}));
